import React from "react";
import { useTrackedDecision } from "lib/optimizelyDebug";
import {
	OPTIMIZELY_FLAGS,
	SEARCH_RESULTS_PAGE_AA_TEST_VARIATIONS
} from "config/optimizely";
import SearchPageV2 from "./SearchPageV2";

// A/A test (SF-23421): bucket users for reporting verification only.
// Both arms render identically - this validates the FX bucketing/reporting
// pipeline before a real experiment runs on this page.
const SearchPageV2Wrapper = (props) => {
	const [decision] = useTrackedDecision(
		OPTIMIZELY_FLAGS.SEARCH_RESULTS_PAGE_AA_TEST
	);

	switch (decision?.variationKey) {
		case SEARCH_RESULTS_PAGE_AA_TEST_VARIATIONS.VARIATION:
		case SEARCH_RESULTS_PAGE_AA_TEST_VARIATIONS.CONTROL:
		default:
			return <SearchPageV2 {...props} />;
	}
};

export default SearchPageV2Wrapper;
